export { Text } from './Text';
export type { Props } from './Text.types';
